import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

var config = {
  apiKey: "AIzaSyBzoUWcWn6vb9Z1AYIh6UBNTMfU8u4D68Q",
  authDomain: "net-ninja-marioplan-a8426.firebaseapp.com",
  databaseURL: "https://net-ninja-marioplan-a8426.firebaseio.com",
  projectId: "net-ninja-marioplan-a8426",
  storageBucket: "net-ninja-marioplan-a8426.appspot.com",
  messagingSenderId: "585579965136"
};
firebase.initializeApp(config);
firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase;
